import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { useAddCoOwnerModal } from '../context/AddCoOwnerModalContext';

const AddCoOwnerModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddCoOwnerModal();

  const isDisabled =
    (!data.name && !data.selectedPartner) ||
    !data.cif ||
    !data.isValidPercent ||
    !data.isValidEmail ||
    (data.modalActionType === actionTypes.EDIT && !data.hasBeenEdited);

  return (
    <Modal.Footer>
      <Button
        onClick={actions.handleSave}
        text={t('Save')}
        disabled={isDisabled}
        lgSize
      />
    </Modal.Footer>
  );
};

export default AddCoOwnerModalFooter;
